import { NgIf } from '@angular/common';
import { AfterViewInit, Component, NgZone } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import * as firebaseui from 'firebaseui';
import { firebase } from 'firebaseui-angular';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    NgIf,
    MatProgressSpinnerModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements AfterViewInit {

  private ui: firebaseui.auth.AuthUI | null = null;
  public spinnerOn = true;
  public checkGoogle = false;
  public firebaseuiShow = true;

  private googleButton: Element | null = null;
  private googleButtonClickListener?: EventListener;

  constructor(
    private auth: AuthService,
    private ngZone: NgZone,
    private router: Router
  ) {}

  ngAfterViewInit(): void {
    this.initFirebaseUI();
  }

  ngOnDestroy() {
    if (this.googleButton && this.googleButtonClickListener)
      this.googleButton.removeEventListener('click', this.googleButtonClickListener);
    if (this.ui)
      this.ui.reset();
  }

  private onGoogleButtonClick() {
    this.firebaseuiShow = false;
    this.spinnerOn = true;
    this.checkGoogle = true;
  }

  private initFirebaseUI(): void {
    const self = this;
    this.ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(this.auth.auth);
    this.ui.reset();
    this.ui.start('#firebaseui-auth-container', {
      callbacks: {
        signInFailure: (err) => { console.log("CALLBACK signInFailure", err)},
        signInSuccessWithAuthResult: this.onSignInSuccess.bind(this),
        uiShown: function() {
          self.spinnerOn = false;
          self.googleButton = document.querySelector('#firebaseui-auth-container button[data-provider-id="google.com"]');
          
          // Rimuovi eventuali listener esistenti per evitare duplicazioni
          if ( self.googleButton && self.googleButtonClickListener ) {
            self.googleButton.removeEventListener('click', self.googleButtonClickListener);
          }

          // Aggiungi il listener per il pulsante Google
          if ( self.googleButton ) {
            self.googleButtonClickListener = self.onGoogleButtonClick.bind(self); // Salva il riferimento alla funzione
            self.googleButton.addEventListener('click', self.googleButtonClickListener);
          }
        }
      },
      signInFlow: 'popup',
      signInOptions: [
        { 
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          customParameters: { prompt: 'select_account'}
        },
      ],

      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
 
      tosUrl: '/',
      privacyPolicyUrl: '/'   
    });
  }

  private onSignInSuccess() {
    this.ngZone.run(() => {
        this.router.navigate(['/']);
    });
    return false;
  }

  public reloadPage() {
    window.location.reload();
  }

}
